import moment from 'moment';

export const formatCurrency = (value) => {
  if (!value) return '';
  
  // Convert string to number if needed
  const numericValue = typeof value === 'string' ? parseFloat(value) : value;
  
  // Check if the conversion resulted in a valid number
  if (isNaN(numericValue)) return '';
  
  return numericValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
};

export const formatDate = (date) => {
  if (!date) return '';
  return moment(date).fromNow();
};

export const formatFullDate = (date) => {
  if (!date) return '';
  return moment(date).format('DD/MM/YYYY HH:mm');
};

export const formatShortDate = (date) => {
  if (!date) return '';
  return moment(date).format('DD/MM/YYYY');
};